import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import {
  map,
  takeUntil
} from 'rxjs/operators';
import { ClientCreateResponse, ClientDataResponse } from 'src/app/models/client/client.interface';
import { CaseService } from 'src/app/services/case.service';
import { ClientContactService } from 'src/app/services/client-contact.service';
import { ClientService } from 'src/app/services/client.service';

@Component({
  selector: 'app-client-information',
  templateUrl: './client-information.component.html',
  styleUrls: ['./client-information.component.css'],
})
export class ClientInformationComponent implements OnInit, OnDestroy {
  @Output() formSubmitted: EventEmitter<boolean> = new EventEmitter<boolean>();
  preloaderCaseType: boolean;
  private unsubscribe$ = new Subject<void>();
  preloaderClientName: boolean;
  clientLocations = [];
  clientInformationForm: FormGroup;
  preloaderCaseService: boolean;
  clientPrograms = [];
  programLocationContacts = [];
  isClientFormSubmitted: boolean;
  addClientForm: FormGroup;

  constructor(
    private caseService: CaseService,
    private clientContactService: ClientContactService,
    private clientService: ClientService,
    private fb: FormBuilder,
    private addmodalService: NgbModal,
    private toastr: ToastrService,
    private _datePipe: DatePipe,
  ) {}

  ngOnInit() {
    this.initForm();
    this.prefillClientInformation();
  }

  initForm() {
    this.clientInformationForm = this.fb.group({
      claim_reference_no: [''],
      case_type: ['', []],
      client: [''],
      location: [''],
      program_name: [''],
      primary_contact: [''],
      companion_file: [''],
      case_service: [[]],
      insured_date: [''],
      dol: [''],
      policy_number: [''],
      policy_period_from_date: [''],
      policy_period_to_date: [''],
    });

    this.addClientForm = this.fb.group({
      name: new FormControl('', [Validators.required]),
    });
  }

  prefillClientInformation() {
    const clientInformationForm = this.caseService.caseDataValue?.clientInformation;

    if (clientInformationForm) {
      this.clientInformationForm.patchValue(clientInformationForm);
    }
  }

  onSubmitForm() {
    if (this.clientInformationForm.invalid) {
      this.clientInformationForm.markAllAsTouched();
      this.clientInformationForm.updateValueAndValidity();
      return;
    }

    console.log(this.clientInformationForm.value);

    const {
      case_type,
       case_service,
       client,
       location,
       primary_contact,
       claim_reference_no,
       companion_file,
       insured_date,
       dol,
       policy_number,
       policy_period_from_date,
       policy_period_to_date
       } = this.clientInformationForm.value;

    const reqBody = {
      "case": {
        "case_type": case_type?.id,
        "case_services": case_service?.length ? case_service.map((service) => service.id) : null
      },
      "claim": {
        "client": client?.id || null,
        "program_location": location?.id || null,
        "client_contact": primary_contact?.id || null,
        "claim_number": claim_reference_no || null,
         companion_file : companion_file || null,
        "insured": insured_date || null,
        "dol": dol || null,
        policy_number: policy_number || null,
        "policy_period_from": policy_period_from_date || null,
        "policy_period_to": policy_period_to_date || null
      }
    };

    this.caseService.createCaseClientInformation(reqBody)
    .pipe(
      takeUntil(this.unsubscribe$)
    )
    .subscribe(
      (res) => {
        this.toastr.success(res?.details?.message);
        this.formSubmitted.emit(true);
        this.caseService.setCaseData({
          clientInformation: this.clientInformationForm.value,
          saved_case_data: res?.details?.data,
        });
      },
      ({ error }: HttpErrorResponse) => {
        this.toastr.error(error?.errors[0]);
      }
    );
  }

  getClientLocation(clientId: number) {
    this.clientService
      .fetchClientLocations(clientId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.clientLocations = res?.hits || [];
      });
  }

  onChangeLocation(location) {
    const { client } = this.clientInformationForm.value;
    this.clientContactService
      .getClientProgramNames(client.id, location.program_name)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: any) => {
        this.clientPrograms = res?.hits || [];
      });
  }

  onChangeProgram(programId: number) {
    console.log('on change program');
    this.clientContactService
      .getProgramLocationContacts(programId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res: any) => {
        this.programLocationContacts = res?.hits || [];
      });
  }

  addClientData() {
    if (this.addClientForm.invalid) {
      return;
    }

    this.isClientFormSubmitted = true;

    this.clientService
      .saveClient(this.addClientForm.value)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res: ClientDataResponse<ClientCreateResponse>) => {
          // this.toastr.success(res?.details?.message);
          this.toastr.success("Client added successfully");
          this.addmodalService.dismissAll();
          this.addClientForm.reset();
          this.isClientFormSubmitted = false;
          this.addmodalService.dismissAll();
        },
        (error: ClientDataResponse<ClientCreateResponse>) => {
          this.isClientFormSubmitted = false;
          this.toastr.success(error?.errors[0]);
        }
      );
  }

  openPopup(content, size = 'md', service = this.addmodalService) {
    service.open(content, {
      ariaDescribedBy: 'modal-basic-title',
      windowClass: 'groupModal',
      size,
      centered: true,
    });
  }

  onBlurSearchDropDown(
    loader: boolean,
    event: FocusEvent,
    formControl: AbstractControl | null = null
  ): void {
    loader = false;
    const target = event.target as HTMLInputElement;

    if (!formControl?.value || formControl.value === '') {
      target.value = '';
    }
  }

  searchClient$ = (term: string): Observable<any[]> =>{
    return this.clientService.fetchClients(10, 1, term).pipe(
      map((res) => res?.details?.hits || [])
    );
  }

  searchCaseType$ = (term: string): Observable<any> => {
    return this.caseService.getCaseType(10, 1, term);
  };

  searchKeyServices$ = (term: string): Observable<any> => {
    return this.clientContactService.getCaseServices(10, 1, term);
  };

  onChangeClient(clientId:number){
    this.getClientLocation(clientId);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
